export const SUPPORT_FORM_LINK = 'https://go.gov.sg/formsg-support'
export const PUBLIC_PAYMENTS_GUIDE_LINK =
  'https://go.gov.sg/formsg-guide-payments'

export const SGID_VALID_ORG_PAGE =
  'https://docs.id.gov.sg/faq-users#as-a-government-officer-why-am-i-not-able-to-login-to-my-work-tool-using-sgid'
